var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLayoutEffect, useMemo, useState } from "react";
import { getItemSize } from "../menu/Menu.style";
const calcNbVisibleItems = (options, dropdownVisibleItems) => {
    let optionRealLength = 0;
    let lastGroup = undefined;
    // Adding Group headers to the element count
    options.forEach((el) => {
        if (el.group && el.group !== lastGroup) {
            lastGroup = el.group;
            optionRealLength++;
        }
        optionRealLength++;
    });
    return optionRealLength > 0 ? Math.min(dropdownVisibleItems, optionRealLength) : undefined;
};
const scrollItemToTopOfContainer = (item, scrollableContainer) => {
    const itemRect = item.getBoundingClientRect();
    const parentRect = scrollableContainer.getBoundingClientRect();
    const scrollBy = itemRect.top - parentRect.top;
    scrollableContainer.scrollTo({ top: scrollBy });
};
export const useCalculateVisibleItems = ({ dropdownVisibleItems, floatingUpdate, dropdownRef, visible, hasSearch, multiSelect, asyncSearch, size, options, filteredOptions, selectedOptions, selectedOption, unSelectedInitialOptions, }) => {
    const [autoCalcVisibleItems, setAutoCalcVisibleItems] = useState();
    const menuItemSize = useMemo(() => getItemSize({ size, multiSelect }), [size, multiSelect]);
    const visibleItems = useMemo(() => {
        if (dropdownVisibleItems === "auto") {
            if (autoCalcVisibleItems === undefined) {
                return undefined;
            }
            if ((filteredOptions || options).length < autoCalcVisibleItems) {
                return calcNbVisibleItems(filteredOptions || options, autoCalcVisibleItems);
            }
            return autoCalcVisibleItems;
        }
        return calcNbVisibleItems(filteredOptions || options, dropdownVisibleItems);
    }, [options, dropdownVisibleItems, filteredOptions, autoCalcVisibleItems]);
    const asyncSearchVisibleItems = useMemo(() => {
        const itemsToDisplay = dropdownVisibleItems === "auto" ? autoCalcVisibleItems : dropdownVisibleItems;
        if (itemsToDisplay === undefined) {
            return undefined;
        }
        if (multiSelect) {
            return calcNbVisibleItems(selectedOptions ? [...selectedOptions, ...unSelectedInitialOptions] : unSelectedInitialOptions, itemsToDisplay);
        }
        else {
            return calcNbVisibleItems(selectedOption
                ? [{ value: "any", label: "any" }, selectedOption, ...unSelectedInitialOptions]
                : [{ value: "any", label: "any" }, ...unSelectedInitialOptions], itemsToDisplay);
        }
    }, [selectedOption, selectedOptions, unSelectedInitialOptions, autoCalcVisibleItems]);
    useLayoutEffect(() => {
        if (!visible) {
            setAutoCalcVisibleItems(undefined);
        }
        else {
            // dropdown height should not exceed 40% of viewport height
            const maxDropdownHeight = window.innerHeight * 0.4;
            const andMoreHeight = 28;
            const searchHeight = 36;
            const multiSelectClearSelectionHeight = 32;
            const availableHeightForMenuItems = maxDropdownHeight -
                (hasSearch ? searchHeight : 0) -
                (multiSelect ? multiSelectClearSelectionHeight : 0) -
                (asyncSearch && !asyncSearch.hideAndMore ? andMoreHeight : 0);
            const numItems = Math.floor(availableHeightForMenuItems / menuItemSize);
            setAutoCalcVisibleItems(numItems);
        }
    }, [visible]);
    useLayoutEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield floatingUpdate();
            const firstSelectedItem = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.querySelector("li[aria-checked='true']");
            if (firstSelectedItem && dropdownRef) {
                const parent = dropdownRef.querySelector("[role='listbox']");
                scrollItemToTopOfContainer(firstSelectedItem, parent);
            }
        }))();
    }, [dropdownRef, autoCalcVisibleItems]);
    return { visibleItems, asyncSearchVisibleItems };
};
//# sourceMappingURL=useCalculateVisibleItems.js.map